<template>
  <div class="topup-footer">
    <div class="topup-footer-links">
      <a id="link-terms" href="/files/wrodzinie/Regulamin-doladowan-wRodzinie.pdf" target="_blank" rel="noreferrer">Regulamin</a>
      <a id="link-invoice" href="https://faktury.autopay.pl" target="_blank" rel="noreferrer">Faktura za doładowanie</a>
      <a id="link-faq" href="https://wrodzinie.com.pl/pomoc" target="_blank" rel="noreferrer">Najczęściej zadawane pytania</a>
    </div>
    <div class="topup-footer-copyrights">
      © {{ year }} Polkomtel Sp. z o.o. Wszelkie prawa zastrzeżone
    </div>
  </div>
</template>

<script>
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupFooter',
  data () {
    return {
      year: ToolsClass.getCurrentYear()
    }
  }
}
</script>

<style src="../../assets/scss/footer.scss" lang="scss"></style>
